import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <>
      <div className="nf-wrap">
        <div className="nf-code">404</div>
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-message">The page you're looking for doesn't exist in the admin.</p>
        <Link to="/dashboard" className="nf-link">← Back to Dashboard</Link>
      </div>

      <style>{`
        .nf-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 60vh;
          gap: 12px;
          text-align: center;
        }
        .nf-code {
          font-size: 5rem;
          font-weight: 800;
          color: var(--border);
          font-family: var(--font-mono);
          line-height: 1;
        }
        .nf-title {
          font-size: 1.4rem;
          color: var(--text-primary);
          font-weight: 600;
        }
        .nf-message {
          color: var(--text-muted);
          font-size: 0.9rem;
        }
        .nf-link {
          margin-top: 8px;
          color: var(--accent);
          font-size: 0.875rem;
          font-weight: 500;
          text-decoration: none;
        }
        .nf-link:hover { text-decoration: underline; }
      `}</style>
    </>
  )
}
